module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isExit) ? _c('div', {
    staticClass: "image image--exit"
  }) : _c('div', {
    staticClass: "image image--return"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5aeb841c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/rondes/ExitReturnImage.vue
// module id = 1820
// module chunks = 2